import React from "react";
import { Margin, usePDF } from "react-to-pdf";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Phuluc5ct from "components/Tonghopvantai/Phuluc5ct.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

export default function Phuluc5() {
  const [thangnam, setThangnam] = React.useState(dayjs());
  const { toPDF, targetRef } = usePDF({
    filename: "Baocaohoatdongvantai.pdf",
    page: { margin: Margin.MEDIUM },
  });
  const exportToExcel = () => {
    const element = targetRef.current;
    if (!element) return;
    // Tìm bảng trong component con
    const table = element.querySelector("table");
    if (!table) {
      alert("Không tìm thấy bảng dữ liệu để xuất Excel");
      return;
    }

    const workbook = XLSX.utils.table_to_book(table, { sheet: "BaoCao" });

    XLSX.writeFile(
      workbook,
      `Baocaohoatdongvantai_${thangnam.format("MM_YYYY")}.xlsx`
    );
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "13%", marginLeft: "10px" }}>
          <Button
            color="success"
            variant="contained"
            onClick={toPDF}
            style={{ height: 27 }}
          >
            Tải file PDF
          </Button>
        </FormControl>
        <FormControl style={{ width: "13%", marginLeft: "10px" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={exportToExcel}
            style={{ height: 27 }}
          >
            Xuất Excel
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <div ref={targetRef} style={{ height: "auto" }}>
          {thangnam && <Phuluc5ct thangnam={thangnam} />}
        </div>
      </GridItem>
    </GridContainer>
  );
}
